<template>
  <!--ATTENZIONE: per l'istituto angelo mosso bisogna sistemare i link delle icone colorate!-->
  <div>
    <div class="page-header clear-filter" filter-color="blue">
      <parallax class="page-header-image"
        :style="isGeodidalab ? { 'background-image': 'url(' + imageUrlGeodidalab + ')' } : { 'background-image': 'url(' + imageUrlIstitutoMosso + ')' }">
      </parallax>
      <div class="container">
        <div class="photo-container" :style="!isGeodidalab ? 'background-color: aliceblue;' : ''">
          <img v-if="isGeodidalab" :src="require('../assets/images/squared_logo.jpg')" alt="" />
          <img v-else :src="require('../assets/images/istitutomosso/Logo_Contatti.jpg')" alt="" />

          <!-- <h4 v-if="!isGeodidalab" class="m-3 text-black"><b>I</b>STITUTO <b>A</b>NGELO <b>M</b>OSSO</h4> -->
        </div>
        <h3 class="title">CONTATTI</h3>
      </div>
    </div>
    <div class="section">
      <div class="container">
        <div class="button-container">
          <a href="https://www.youtube.com/channel/UCd_IuvgQhwSKifqxDT0ikFw" class="btn youtube-color btn-round btn-lg btn-icon"
            rel="tooltip" title="Follow me on Instagram">
            <i class="fab fa-youtube"></i>
          </a>
          <a href="https://it-it.facebook.com/Geodidalab/" class="btn facebook-color btn-round btn-lg btn-icon"
            rel="tooltip" title="Vieni a trovarci su facebook!">
            <i class="fab fa-facebook"></i>
          </a>
          <a href="https://api.whatsapp.com/send?phone=393332923953&app=facebook&entry_point=page_cta"
            class="btn whatsapp-color btn-round btn-lg btn-icon" rel="tooltip" title="Scrivici su whatsapp!">
            <i class="fab fa-whatsapp"></i>
          </a>
          <a href="mailto: info@geodidalab.it" class="btn mail-color btn-round btn-lg btn-icon" rel="tooltip"
            title="Scrivici via mail!">
            <i class="fab fa fa-envelope mt-0 pt-0"></i>
          </a>
        </div>
        <h3 class="title mobile-subtitle">Puoi contattarci nei seguenti modi</h3>
        <h5 v-if="isGeodidalab" class="text-center"><i class="bi bi-telephone-fill"></i> 333 292 3953</h5>
        <h5 v-else class="text-center"><i class="bi bi-telephone-fill"></i> NUMERO ISTITUTO ANGELO MOSSO</h5>

        <h5 v-if="isGeodidalab" class="text-center"><i class="fab fa-whatsapp"></i><a
            href="https://api.whatsapp.com/send?phone=393332923953&app=facebook&entry_point=page_cta" class="a_collapse"> +39 333 292
            3953</a></h5>
        <h5 v-else class="text-center"><i class="fab fa-whatsapp"></i><a
            href="https://api.whatsapp.com/send?phone=393332923953&app=facebook&entry_point=page_cta" class="a_collapse"> SISTEMARE IL
            NUMERO E IL LINK PER ISTITUTO ANGELO MOSSO</a></h5>

        <h5 v-if="isGeodidalab" class="text-center">
          <i class="fa fa-envelope"></i>
          <a href="mailto: info@geodidalab.it" class="a_collapse"> info@geodidalab.it </a>
        </h5>
        <h5 v-else class="text-center">
          <i class="fa fa-envelope"></i>
          <a href="mailto: info@geodidalab.it" class="a_collapse"> SISTEMARE MAIL ISTITUTO ANGELO MOSSO</a>
        </h5>

      </div>
    </div>
  </div>
</template>
<script>
import { config } from '../utils/config';

export default {
  name: "contatti",
  bodyClass: "contact-page",
  components: {},

  data() {
    return {
      imageUrlGeodidalab: require("../assets/images/canoe-scaled.jpg.webp"),
      imageUrlIstitutoMosso: require("../assets/images/istitutomosso/istitutoMossoIndex.jpg"),
      isGeodidalab: true,
    };
  },

  mounted(){
    this.isGeodidalab = config.isGeodidalab;
  }
};
</script>
<style>
.whatsapp-color {
  background-color: #58be67 !important;
}

.whatsapp-color:hover {
  background-color: #6daf77 !important;
}

.facebook-color {
  background-color: #3b5998 !important;
}

.facebook-color:hover {
  background-color: #6388d5 !important;
}

.mail-color {
  background-color: #b4c9f7 !important;
}

.mail-color:hover {
  background-color: rgb(131, 151, 196) !important;
}

.youtube-color {
  background-color: #e65b43 !important;
}

.youtube-color:hover {
  background-color: #e87662 !important;
}
</style>
